module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-14-8bb197309e90d4d1bb1095ed1602b0b5.png";